import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";

// Category Images
import audio from "../../assets/category/audio.webp";
import beverages from "../../assets/category/bevarages.webp";
import grocery from "../../assets/category/grocery.webp";
import health from "../../assets/category/health and wellness.webp";
import homeappliances from "../../assets/category/homeappliances.webp";
import kitchen from "../../assets/category/kitchen appliances.webp";
import nuts from "../../assets/category/nuts.webp";
import perfumes from "../../assets/category/perfumes.webp";
import snacks from "../../assets/category/snacks.webp";
import tv from "../../assets/category/tv.webp";

// New Images
import specialtyfood from "../../assets/category/specialtyfood.webp";
import rice from "../../assets/category/rice.webp";
import oils from "../../assets/category/oils.webp";
import icecream from "../../assets/category/icecream.webp";
import cleaning from "../../assets/category/cleaning.webp";
import mobiles from "../../assets/category/mobiles.webp";

const CategorySection = () => {
  const location = useLocation();
  const [prevLocation, setPrevLocation] = useState("");

  useEffect(() => {
    setPrevLocation(location?.state?.data || "Home");
  }, [location]);

  const categories = [
    { id: 1, name: "Audio", image: audio },
    { id: 2, name: "Beverages", image: beverages },
    { id: 3, name: "Grocery", image: grocery },
    { id: 4, name: "Health & Wellness", image: health },
    { id: 5, name: "Home Appliances", image: homeappliances },
    { id: 6, name: "Kitchen Appliances", image: kitchen },
    { id: 7, name: "Nuts", image: nuts },
    { id: 8, name: "Perfumes", image: perfumes },
    { id: 9, name: "Snacks", image: snacks },
    { id: 10, name: "Television", image: tv },

    // New Categories
    { id: 11, name: "Specialty Food", image: specialtyfood },
    { id: 12, name: "Rice", image: rice },
    { id: 13, name: "Oils", image: oils },
    { id: 14, name: "Ice Cream", image: icecream },
    { id: 15, name: "Cleaning", image: cleaning },
    
  ];

  return (
    <div className="w-full bg-gray-50">

      {/* Hero Section */}
      <div className="w-full bg-gradient-to-r from-black to-gray-800 py-16 text-center text-white">
        <h1 className="text-4xl md:text-5xl font-bold tracking-wide">
          Explore Our Categories
        </h1>

        <p className="mt-4 text-gray-300 text-lg max-w-[700px] mx-auto">
          Discover groceries, electronics, perfumes, snacks and more.
          Shop everything you need in one place.
        </p>
      </div>

      <div className="max-w-container mx-auto px-4 py-12">

        <Breadcrumbs title="Category" prevLocation={prevLocation} />

        {/* Category Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 mt-10">

          {categories.map((category) => (
            <motion.div
              key={category.id}
              whileHover={{ scale: 1.05 }}
              className="group bg-white rounded-xl shadow-lg overflow-hidden cursor-pointer transition duration-300"
            >

              {/* Image */}
              <div className="overflow-hidden">
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-full h-48 object-cover group-hover:scale-110 transition duration-500"
                />
              </div>

              {/* Category Name */}
              <div className="p-4 text-center">
                <h2 className="text-lg font-semibold text-gray-800 group-hover:text-black">
                  {category.name}
                </h2>
              </div>

            </motion.div>
          ))}

        </div>

        {/* Call To Action */}
        <div className="flex flex-col items-center mt-16 bg-white shadow-lg rounded-xl p-10 text-center">

          <h2 className="text-2xl font-bold text-gray-800">
            Need Help Choosing Products?
          </h2>

          <p className="text-gray-500 mt-3 max-w-[500px]">
            Contact our team directly on WhatsApp and get quick assistance for
            your shopping needs.
          </p>

          <a
            href="https://wa.me/971542660433"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 bg-green-500 hover:bg-green-600 text-white px-8 py-3 rounded-lg text-lg font-semibold transition duration-300"
          >
            Chat on WhatsApp
          </a>

        </div>

      </div>
    </div>
  );
};

export default CategorySection;
